"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBlackCardContext = void 0;
const react_1 = require("react");
const blackCardContext_1 = require("root/src/client/v2/common/components/BlackCard/contexts/blackCardContext");
const useBlackCardContext = () => {
    const context = (0, react_1.useContext)(blackCardContext_1.blackCardContext);
    if (!context) {
        throw new Error('useBlackCardContext must be used within a BlackCardContextProvider');
    }
    return context;
};
exports.useBlackCardContext = useBlackCardContext;
